import React from 'react';

import { legacyTextStyles, tv } from '@eluve/components';

const styles = tv({
  base: 'inline-flex flex-shrink-0 text-nowrap rounded-md px-2 py-1',
  variants: {
    type: {
      CPT: 'bg-bg-teal-strong text-text-teal-strong',
      ICD_10: 'bg-bg-lightblue-strong text-text-lightblue-strong',
      ICD_9: 'bg-bg-orange-strong text-text-orange-strong',
      SNOMED: 'bg-bg-purple-strong text-text-purple-strong',
      HCPCS: 'bg-bg-lightgreen-strong text-text-lightgreen-strong',
    },
  },
});

export type CodeType = 'ICD_10' | 'ICD_9' | 'CPT' | 'SNOMED' | 'HCPCS';

export interface MedicalCodeTypeBadgeProps {
  codeType: CodeType;
  label?: string;
}

export const MedicalCodeTypeBadge = React.forwardRef<
  HTMLDivElement,
  MedicalCodeTypeBadgeProps
>(({ codeType, label }, ref) => {
  const className = styles({
    type: codeType,
    className: legacyTextStyles.label({ size: 'l', weight: 'semibold' }),
  });

  return (
    <div ref={ref} className={className}>
      {label ?? codeType.replace('_', '-')}
    </div>
  );
});
